var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-20" },
    [
      _c(
        "van-form",
        {
          ref: "form",
          attrs: { "show-error": false, "error-message-align": "right" },
        },
        [
          _c(
            "van-cell-group",
            [
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "flowNo",
                    expression: "'flowNo'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("flowNo"),
                  rules: _vm.getRules("flowNo"),
                  label: "编号",
                  "input-align": "right",
                  readonly: "",
                },
                model: {
                  value: _vm.formData.flowNo,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "flowNo", $$v)
                  },
                  expression: "formData.flowNo",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "fksqr",
                    expression: "'fksqr'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("fksqr"),
                  name: "flowName",
                  label: "付款申请人",
                  placeholder: "付款申请人",
                  "input-align": "right",
                  rules: _vm.getRules("fksqr"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            treeData: _vm.deptUserTreeAll.data,
                            value: _vm.formData.fksqr,
                            placeholder: "请选择付款申请人",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(
                                _vm.deptUserTreeAll,
                                "fksqr"
                              )
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.deptUserTreeAll.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.deptUserTreeAll, "show", $$v)
                              },
                              expression: "deptUserTreeAll.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择付款申请人",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.deptUserTreeAll.show = false
                                },
                                "click-right": _vm.handlePopupSubmit,
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.treeSearch($event, _vm.$refs.tree)
                                },
                              },
                              model: {
                                value: _vm.deptUserTreeAll.filterText,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.deptUserTreeAll,
                                    "filterText",
                                    $$v
                                  )
                                },
                                expression: "deptUserTreeAll.filterText",
                              },
                            }),
                            _c(
                              "div",
                              {
                                staticClass: "h-vh-35",
                                staticStyle: { "overflow-y": "auto" },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "p-10" },
                                  [
                                    _c("el-tree", {
                                      ref: "tree",
                                      attrs: {
                                        "node-key": "uuid",
                                        "check-strictly": "",
                                        data: _vm.deptUserTreeAll.data,
                                        "filter-node-method": _vm.filterNode,
                                        "check-on-click-node": "",
                                        "show-checkbox": "",
                                      },
                                      on: {
                                        "check-change": function ($event) {
                                          return _vm.singleChoice(
                                            $event,
                                            _vm.$refs.tree
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.fksqr,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "fksqr", $$v)
                  },
                  expression: "formData.fksqr",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "sqr",
                    expression: "'sqr'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("sqr"),
                  name: "flowName",
                  label: "申请人",
                  placeholder: "申请人",
                  "input-align": "right",
                  rules: _vm.getRules("sqr"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.sqr,
                            placeholder: "请选择申请人",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.sqr,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "sqr", $$v)
                  },
                  expression: "formData.sqr",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "ssbm",
                    expression: "'ssbm'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "ssbm",
                  required: _vm.isRequired("ssbm"),
                  value: _vm.formData.ssbm,
                  label: "部门",
                  rules: _vm.getRules("ssbm"),
                  placeholder: "请选择部门",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.ssbm,
                            placeholder: "请选择部门",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.ssbm, "ssbm")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.ssbm.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.ssbm, "show", $$v)
                              },
                              expression: "ssbm.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择部门",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.ssbm.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("ssbm", {
                                    label: "label",
                                    value: "value",
                                  })
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch(
                                    $event,
                                    _vm.ssbm,
                                    "label"
                                  )
                                },
                              },
                              model: {
                                value: _vm.ssbm.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ssbm, "filterText", $$v)
                                },
                                expression: "ssbm.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "ssbm",
                              attrs: {
                                "value-key": "label",
                                columns: _vm.ssbm.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.ssbm.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "hsgs",
                    expression: "'hsgs'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "hsgs",
                  value: _vm.formData.hsgs,
                  rules: _vm.getRules("hsgs"),
                  label: "核算公司",
                  placeholder: "请选择核算公司",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.hsgs,
                            placeholder: "请选择核算公司",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.hsgs, "hsgs")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.hsgs.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.hsgs, "show", $$v)
                              },
                              expression: "hsgs.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择核算公司",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.hsgs.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("hsgs", {
                                    label: "name",
                                    value: "id",
                                  })
                                },
                              },
                            }),
                            _c("van-picker", {
                              ref: "hsgs",
                              attrs: {
                                duration: 0,
                                "value-key": "name",
                                columns: _vm.hsgs.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.hsgs.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "ssxm",
                    expression: "'ssxm'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "ssxm",
                  required: _vm.isRequired("ssxm"),
                  value: _vm.formData.ssxm,
                  rules: _vm.getRules("ssxm"),
                  label: "关联业务",
                  placeholder: "请选择项目/合同",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.ssxm.split(",")[1],
                            placeholder: "请选择项目/合同",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.ssxm, "ssxm")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.ssxm.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.ssxm, "show", $$v)
                              },
                              expression: "ssxm.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择项目/合同",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.ssxm.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.businessSelectFinish("ssxm")
                                },
                              },
                            }),
                            _c(
                              "van-row",
                              {
                                staticClass: "p-r-20",
                                attrs: { type: "flex", align: "center" },
                              },
                              [
                                _c(
                                  "van-col",
                                  { attrs: { span: 18 } },
                                  [
                                    _c("van-search", {
                                      attrs: { clearable: "", shape: "round" },
                                      on: {
                                        input: function ($event) {
                                          return _vm.pickerSearch(
                                            $event,
                                            _vm.ssxm,
                                            "name",
                                            "columnsLabel"
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.ssxm.filterText,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.ssxm, "filterText", $$v)
                                        },
                                        expression: "ssxm.filterText",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "van-col",
                                  { attrs: { span: 6 } },
                                  [
                                    _c(
                                      "van-button",
                                      {
                                        attrs: {
                                          loading: _vm.btnLoading,
                                          "loading-text": "加载中...",
                                          type: "primary",
                                          "native-type": "button",
                                          size: "small",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectMyProjectList(
                                              "",
                                              true
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("更多项目... ")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("van-picker", {
                              ref: "ssxm",
                              attrs: {
                                duration: 0,
                                "value-key": "columnsLabel",
                                columns: _vm.ssxm.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.ssxm.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "fksy",
                    expression: "'fksy'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("fksy"),
                  required: _vm.isRequired("fksy"),
                  name: "fksy",
                  rules: _vm.getRules("fksy"),
                  type: "textarea",
                  maxlength: "200",
                  rows: "3",
                  autosize: "",
                  label: "付款事由",
                  "show-word-limit": "",
                  placeholder: "请输入付款事由",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.fksy,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "fksy", $$v)
                  },
                  expression: "formData.fksy",
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "font-32 font-weight-500 cor-00 m-t-26" }, [
            _vm._v("付款明细"),
          ]),
          _c(
            "van-cell-group",
            { staticClass: "m-t-20" },
            [
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "fklx",
                    expression: "'fklx'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "fklx",
                  required: _vm.isRequired("fklx"),
                  rules: _vm.getRules("fklx"),
                  value: _vm.formData.fklx,
                  label: "付款类型",
                  placeholder: "请选择付款类型",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.fklx,
                            placeholder: "请选择付款类型",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.fklx, "fklx")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.fklx.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.fklx, "show", $$v)
                              },
                              expression: "fklx.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择付款类型",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.fklx.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("fklx")
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch($event, _vm.fklx)
                                },
                              },
                              model: {
                                value: _vm.fklx.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.fklx, "filterText", $$v)
                                },
                                expression: "fklx.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "fklx",
                              attrs: { columns: _vm.fklx.filteredData },
                              on: {
                                cancel: function ($event) {
                                  _vm.fklx.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "zmlx",
                    expression: "'zmlx'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "zmlx",
                  required: _vm.isRequired("zmlx"),
                  rules: _vm.getRules("zmlx"),
                  label: "账套类型",
                  placeholder: "请选择账套类型",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _vm.isDisabled("zmlx")
                          ? _c("view-item", {
                              attrs: { showLabel: _vm.formData.zmlx },
                            })
                          : _c(
                              "van-checkbox-group",
                              {
                                staticStyle: { display: "flex" },
                                attrs: { "checked-color": "rgb(255,218,62)" },
                                model: {
                                  value: _vm.formData.zmlx,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "zmlx", $$v)
                                  },
                                  expression: "formData.zmlx",
                                },
                              },
                              [
                                _c(
                                  "van-checkbox",
                                  {
                                    staticStyle: { "margin-right": "10px" },
                                    attrs: { name: "管理账套" },
                                  },
                                  [_vm._v("管理账套")]
                                ),
                                _c(
                                  "van-checkbox",
                                  { attrs: { name: "核算账套" } },
                                  [_vm._v("核算账套")]
                                ),
                              ],
                              1
                            ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "fkze",
                    expression: "'fkze'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("fkze"),
                  type: "number",
                  name: "fkze",
                  rules: _vm.getRules("fkze"),
                  required: _vm.isRequired("fkze"),
                  maxlength: 10,
                  placeholder: "请输入付款总额",
                  label: "付款总额(元)",
                  "input-align": "right",
                },
                on: {
                  change: function ($event) {
                    return _vm.formatToTwoDecimals(_vm.formData, "fkze")
                  },
                },
                model: {
                  value: _vm.formData.fkze,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "fkze", $$v)
                  },
                  expression: "formData.fkze",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "fkze",
                    expression: "'fkze'",
                  },
                ],
                attrs: {
                  center: "",
                  rules: _vm.getRules("fkze"),
                  required: _vm.isRequired("fkze"),
                  label: "",
                  "input-align": "right",
                  readonly: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("div", [
                          _vm.formData.fkze && _vm.formData.fkze != 0
                            ? _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.getFormatValue(_vm.formData.fkze) +
                                      " 元"
                                  ),
                                },
                              })
                            : _c("span", [_vm._v("无")]),
                          _vm.formData.fkze && _vm.formData.fkze != 0
                            ? _c("div", [
                                _c("span", { staticClass: "p-l-20" }, [
                                  _vm._v(" 大写："),
                                ]),
                                _c("span", { staticClass: "cor-F64646" }, [
                                  _vm._v(
                                    _vm._s(_vm.getChinese(_vm.formData.fkze))
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.fkze,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "fkze", $$v)
                  },
                  expression: "formData.fkze",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "zfrq",
                    expression: "'zfrq'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("zfrq"),
                  name: "zfrq",
                  label: "支付日期",
                  placeholder: "支付日期",
                  "input-align": "right",
                  rules: _vm.getRules("zfrq"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.zfrq,
                            placeholder: "请选择支付日期",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.zfrq, "zfrq")
                            },
                          },
                        }),
                        _c("van-calendar", {
                          ref: "zfrq",
                          attrs: {
                            "min-date": _vm.zfrq.minDate,
                            "max-date": _vm.zfrq.maxDate,
                            "show-confirm": false,
                            title: "选择支付日期",
                          },
                          on: { confirm: _vm.zfrqConfirm },
                          model: {
                            value: _vm.zfrq.show,
                            callback: function ($$v) {
                              _vm.$set(_vm.zfrq, "show", $$v)
                            },
                            expression: "zfrq.show",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.zfrq,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "zfrq", $$v)
                  },
                  expression: "formData.zfrq",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "fkfs",
                    expression: "'fkfs'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "fkfs",
                  required: _vm.isRequired("fkfs"),
                  rules: _vm.getRules("fkfs"),
                  value: _vm.formData.fkfs,
                  label: "付款方式",
                  placeholder: "请选择付款方式",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.fkfs,
                            placeholder: "请选择付款方式",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.fkfs, "fkfs")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.fkfs.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.fkfs, "show", $$v)
                              },
                              expression: "fkfs.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择付款方式",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.fkfs.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("fkfs")
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch($event, _vm.fkfs)
                                },
                              },
                              model: {
                                value: _vm.fkfs.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.fkfs, "filterText", $$v)
                                },
                                expression: "fkfs.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "fkfs",
                              attrs: { columns: _vm.fkfs.filteredData },
                              on: {
                                cancel: function ($event) {
                                  _vm.fkfs.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c(
                "div",
                { staticClass: "flex row-between col-center m-t-20" },
                [
                  _c(
                    "van-button",
                    {
                      attrs: {
                        size: "small",
                        type: "primary",
                        "native-type": "button",
                      },
                      on: {
                        click: function ($event) {
                          _vm.account.show = true
                        },
                      },
                    },
                    [_vm._v("选择支付对象 ")]
                  ),
                ],
                1
              ),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "zfdx",
                    expression: "'zfdx'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("zfdx"),
                  required: _vm.isRequired("zfdx"),
                  name: "zfdx",
                  rules: _vm.getRules("zfdx"),
                  maxlength: "50",
                  autosize: "",
                  label: "支付对象",
                  placeholder: "请输入支付对象",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.zfdx,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "zfdx", $$v)
                  },
                  expression: "formData.zfdx",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "yhzh",
                    expression: "'yhzh'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("yhzh"),
                  required: _vm.isRequired("yhzh"),
                  name: "yhzh",
                  rules: _vm.getRules("yhzh"),
                  maxlength: "50",
                  autosize: "",
                  label: "账号",
                  placeholder: "请输入账号",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.yhzh,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "yhzh", $$v)
                  },
                  expression: "formData.yhzh",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "khh",
                    expression: "'khh'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("khh"),
                  required: _vm.isRequired("khh"),
                  name: "khh",
                  rules: _vm.getRules("khh"),
                  maxlength: "50",
                  autosize: "",
                  label: "开户行",
                  placeholder: "请输入开户行",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.khh,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "khh", $$v)
                  },
                  expression: "formData.khh",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "skrfkbz",
                    expression: "'skrfkbz'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("skrfkbz"),
                  required: _vm.isRequired("skrfkbz"),
                  rules: _vm.getRules("skrfkbz"),
                  name: "skrfkbz",
                  type: "textarea",
                  maxlength: "200",
                  rows: "3",
                  autosize: "",
                  label: "付款备注",
                  "show-word-limit": "",
                  placeholder:
                    "请在填写付款备注时，避免使用 “福利、劳务费、工资、薪贴、奖金” 等相关表述。",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.skrfkbz,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "skrfkbz", $$v)
                  },
                  expression: "formData.skrfkbz",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "skrbz",
                    expression: "'skrbz'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("skrbz"),
                  required: _vm.isRequired("skrbz"),
                  rules: _vm.getRules("skrbz"),
                  name: "skrbz",
                  type: "textarea",
                  maxlength: "200",
                  rows: "3",
                  autosize: "",
                  label: "备注",
                  "show-word-limit": "",
                  placeholder: "请输入备注",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.skrbz,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "skrbz", $$v)
                  },
                  expression: "formData.skrbz",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "km",
                    expression: "'km'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("km"),
                  name: "flowName",
                  label: "归属科目",
                  placeholder: "归属科目",
                  "input-align": "right",
                  rules: _vm.getRules("km"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            treeData: _vm.km.data,
                            value: _vm.formData.km,
                            placeholder: "请选择归属科目",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.km, "km")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.km.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.km, "show", $$v)
                              },
                              expression: "km.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择归属科目",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.km.show = false
                                },
                                "click-right": _vm.kmSubmit,
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.treeSearch($event, _vm.$refs.tree)
                                },
                              },
                              model: {
                                value: _vm.km.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.km, "filterText", $$v)
                                },
                                expression: "km.filterText",
                              },
                            }),
                            _c(
                              "div",
                              {
                                staticClass: "h-vh-35",
                                staticStyle: { "overflow-y": "auto" },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "p-10" },
                                  [
                                    _c("el-tree", {
                                      ref: "kmTree",
                                      attrs: {
                                        "node-key": "uuid",
                                        "check-strictly": "",
                                        data: _vm.km.data,
                                        "filter-node-method": _vm.filterNode,
                                        "check-on-click-node": "",
                                        "show-checkbox": "",
                                      },
                                      on: {
                                        "check-change": function ($event) {
                                          return _vm.singleChoice(
                                            $event,
                                            _vm.$refs.kmTree
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.km,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "km", $$v)
                  },
                  expression: "formData.km",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "fj",
                    expression: "'fj'",
                  },
                ],
                staticClass: "fileValueBox",
                attrs: {
                  "input-align": "right",
                  name: "fj",
                  required: _vm.isRequired("fj"),
                  rules: _vm.getRules("fj"),
                  label: "附件",
                  placeholder: "请上传文件",
                },
                domProps: { value: _vm.formData.fj },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("uploadFiles", {
                          attrs: {
                            disabled: _vm.isDisabled("fj"),
                            files: _vm.formData.fj,
                            "module-type": "flow",
                          },
                          on: {
                            success: _vm.uploadSuccess,
                            fileRemove: (removedFile) =>
                              _vm.handleFileRemove(
                                removedFile,
                                "formData",
                                "fj"
                              ),
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
          _vm.formData.fklx == "供应商货款"
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "zcht",
                      expression: "'zcht'",
                    },
                  ],
                },
                [
                  _c(
                    "div",
                    { staticClass: "font-32 font-weight-500 cor-00 m-t-26" },
                    [_vm._v("关联合同")]
                  ),
                  _c(
                    "van-cell-group",
                    { staticClass: "m-t-20" },
                    [
                      _c("van-field", {
                        attrs: {
                          "input-align": "right",
                          name: "zcht",
                          required: _vm.isRequired("zcht"),
                          rules: _vm.getRules("zcht"),
                          value: _vm.formData.zcht,
                          label: "支出合同",
                          placeholder: "请选择支出合同",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "input",
                              fn: function () {
                                return [
                                  _c("view-item", {
                                    attrs: {
                                      value: _vm.formData.zcht,
                                      placeholder: "请选择支出合同",
                                    },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.isShowPopup(_vm.zcht, "zcht")
                                      },
                                    },
                                  }),
                                  _c(
                                    "van-popup",
                                    {
                                      attrs: { position: "bottom" },
                                      model: {
                                        value: _vm.zcht.show,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.zcht, "show", $$v)
                                        },
                                        expression: "zcht.show",
                                      },
                                    },
                                    [
                                      _c("van-nav-bar", {
                                        attrs: {
                                          title: "支出合同",
                                          "left-text": "取消",
                                          "right-text": "确定",
                                        },
                                        on: {
                                          "click-left": function ($event) {
                                            _vm.zcht.show = false
                                          },
                                          "click-right": function ($event) {
                                            return _vm.popupSubmit("zcht", {
                                              label: "contractName",
                                              value: "contractId",
                                            })
                                          },
                                        },
                                      }),
                                      _c(
                                        "van-row",
                                        {
                                          staticClass: "p-r-20",
                                          attrs: {
                                            type: "flex",
                                            align: "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "van-col",
                                            { attrs: { span: 18 } },
                                            [
                                              _c("van-search", {
                                                attrs: {
                                                  clearable: "",
                                                  shape: "round",
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.pickerSearchZcht(
                                                      $event,
                                                      _vm.zcht,
                                                      "contractName"
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: _vm.zcht.filterText,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.zcht,
                                                      "filterText",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "zcht.filterText",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "van-col",
                                            { attrs: { span: 6 } },
                                            [
                                              _c(
                                                "van-button",
                                                {
                                                  attrs: {
                                                    loading: _vm.btnLoading,
                                                    "loading-text": "加载中...",
                                                    type: "primary",
                                                    "native-type": "button",
                                                    size: "small",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.selectZchtList(
                                                        true
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("更多项目... ")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c("van-picker", {
                                        ref: "zcht",
                                        attrs: {
                                          "value-key": "contractName",
                                          columns: _vm.zcht.filteredData,
                                        },
                                        on: {
                                          cancel: function ($event) {
                                            _vm.zcht.show = false
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          2481688401
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              directives: [
                {
                  name: "f-show",
                  rawName: "v-f-show",
                  value: "zffsmxb",
                  expression: "'zffsmxb'",
                },
              ],
            },
            [
              _c(
                "div",
                { staticClass: "font-32 font-weight-500 cor-00 m-t-26 m-b-26" },
                [_vm._v("财务出款")]
              ),
              _vm._l(_vm.formData.zffsmxb, function (item, index) {
                return _c(
                  "van-cell-group",
                  { key: index, staticClass: "b-r-10 m-t-20" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "p-b-20",
                        staticStyle: { "border-bottom": "1px solid #EBEBEB" },
                      },
                      [
                        _c(
                          "van-row",
                          { attrs: { type: "flex", align: "center" } },
                          [
                            _c("van-col", { attrs: { span: 22 } }, [
                              _c("img", {
                                staticClass: "w-5 h-28",
                                attrs: {
                                  src: `${_vm.image_base_url}/icon_line.png`,
                                },
                              }),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "cor-33 font-weight-500 font-28 m-l-16",
                                },
                                [_vm._v(_vm._s(`明细${index + 1}`))]
                              ),
                            ]),
                            _vm.isShowIcon("zffsmxb")
                              ? _c(
                                  "van-col",
                                  {
                                    attrs: { span: 2 },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeItem(index, "zffsmxb")
                                      },
                                    },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "w-30 h-30",
                                      attrs: {
                                        src: `${_vm.image_base_url}/shoppingDel.png`,
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "fkzh",
                          expression: "'fkzh'",
                        },
                      ],
                      attrs: {
                        "input-align": "right",
                        name: "fkzh",
                        rules: _vm.getRules("fkzh"),
                        required: _vm.isRequired("fkzh"),
                        value: item.fkzh,
                        label: "付款账户",
                        placeholder: "请选择付款账户",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "input",
                            fn: function () {
                              return [
                                _c("view-item", {
                                  attrs: {
                                    value: item.fkzh,
                                    placeholder: "请选择付款账户",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.popupShow(
                                        _vm.fkzh.show,
                                        index,
                                        "fkzh"
                                      )
                                    },
                                  },
                                }),
                                _c(
                                  "van-popup",
                                  {
                                    attrs: { position: "bottom" },
                                    model: {
                                      value: _vm.fkzh.show[index],
                                      callback: function ($$v) {
                                        _vm.$set(_vm.fkzh.show, index, $$v)
                                      },
                                      expression: "fkzh.show[index]",
                                    },
                                  },
                                  [
                                    _c("van-nav-bar", {
                                      attrs: {
                                        title: "选择付款账户",
                                        "left-text": "取消",
                                        "right-text": "确定",
                                      },
                                      on: {
                                        "click-left": function ($event) {
                                          return _vm.popupHidden(
                                            _vm.fkzh.show,
                                            index
                                          )
                                        },
                                        "click-right": function ($event) {
                                          return _vm.fkzhSubmit(item, index)
                                        },
                                      },
                                    }),
                                    _c("van-search", {
                                      attrs: { clearable: "", shape: "round" },
                                      on: {
                                        input: function ($event) {
                                          return _vm.pickerSearch(
                                            $event,
                                            _vm.fkzh,
                                            "name"
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.fkzh.filterText,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.fkzh, "filterText", $$v)
                                        },
                                        expression: "fkzh.filterText",
                                      },
                                    }),
                                    _c("van-picker", {
                                      ref: `fkzhPicker_${index}`,
                                      refInFor: true,
                                      attrs: {
                                        "value-key": "name",
                                        columns: _vm.fkzh.filteredData,
                                      },
                                      on: {
                                        cancel: function ($event) {
                                          _vm.fkzh.show = false
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "zffs",
                          expression: "'zffs'",
                        },
                      ],
                      attrs: {
                        "input-align": "right",
                        name: "zffs",
                        rules: _vm.getRules("zffs"),
                        required: _vm.isRequired("zffs"),
                        value: item.zffs,
                        label: "支付方式",
                        placeholder: "请选择支付方式",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "input",
                            fn: function () {
                              return [
                                _c("view-item", {
                                  attrs: {
                                    value: item.zffs,
                                    placeholder: "请选择支付方式",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.popupShow(
                                        _vm.zffs.show,
                                        index,
                                        "zffs"
                                      )
                                    },
                                  },
                                }),
                                _c(
                                  "van-popup",
                                  {
                                    attrs: { position: "bottom" },
                                    model: {
                                      value: _vm.zffs.show[index],
                                      callback: function ($$v) {
                                        _vm.$set(_vm.zffs.show, index, $$v)
                                      },
                                      expression: "zffs.show[index]",
                                    },
                                  },
                                  [
                                    _c("van-nav-bar", {
                                      attrs: {
                                        title: "选择支付方式",
                                        "left-text": "取消",
                                        "right-text": "确定",
                                      },
                                      on: {
                                        "click-left": function ($event) {
                                          return _vm.popupHidden(
                                            _vm.zffs.show,
                                            index
                                          )
                                        },
                                        "click-right": function ($event) {
                                          return _vm.zffsSubmit(item, index)
                                        },
                                      },
                                    }),
                                    _c("van-search", {
                                      attrs: { clearable: "", shape: "round" },
                                      on: {
                                        input: function ($event) {
                                          return _vm.pickerSearch(
                                            $event,
                                            _vm.zffs,
                                            "name"
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.zffs.filterText,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.zffs, "filterText", $$v)
                                        },
                                        expression: "zffs.filterText",
                                      },
                                    }),
                                    _c("van-picker", {
                                      ref: `zffsPicker_${index}`,
                                      refInFor: true,
                                      attrs: {
                                        "value-key": "name",
                                        columns: _vm.zffs.filteredData,
                                      },
                                      on: {
                                        cancel: function ($event) {
                                          _vm.zffs.show = false
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "zfmxje",
                          expression: "'zfmxje'",
                        },
                      ],
                      attrs: {
                        disabled: _vm.isDisabled("zfmxje"),
                        type: "number",
                        name: "zfmxje",
                        rules: _vm.getRules("zfmxje"),
                        required: _vm.isRequired("zfmxje"),
                        maxlength: 10,
                        placeholder: "请输入支付金额",
                        label: "支付金额",
                        "input-align": "right",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.formatToTwoDecimals(_vm.formData, "zfmxje")
                        },
                      },
                      model: {
                        value: item.zfmxje,
                        callback: function ($$v) {
                          _vm.$set(item, "zfmxje", $$v)
                        },
                        expression: "item.zfmxje",
                      },
                    }),
                  ],
                  1
                )
              }),
              !_vm.isDisabled("zffsmxb")
                ? _c(
                    "van-row",
                    [
                      _c("van-col", { attrs: { span: 12 } }),
                      _c(
                        "van-col",
                        { attrs: { span: 12 } },
                        [
                          _c("van-button", {
                            staticClass: "width-100",
                            attrs: {
                              icon: "add-o",
                              round: "",
                              "native-type": "button",
                              color: "#FFDA3E",
                              text: "添加出款明细",
                            },
                            on: { click: _vm.addFKItem },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _c("div", { staticClass: "font-32 font-weight-500 cor-00 m-t-26" }, [
        _vm._v("流程"),
      ]),
      !_vm.$route.query.reSend &&
      (_vm.processInstanceId || _vm.$route.query.processInstanceId)
        ? _c("flowTrace", {
            staticClass: "m-t-20",
            attrs: {
              flowTraceList: _vm.flowTrace,
              processInfo: _vm.processData,
            },
          })
        : _c("approver", {
            ref: "approver",
            staticClass: "m-t-20",
            attrs: {
              processData: _vm.processData,
              formData: _vm.formData,
              formItemMap: _vm.formItemMap,
            },
            on: { addUser: _vm.addUser },
          }),
      _c("bottom-bar", { on: { submit: _vm.submit, mention: _vm.mention } }),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.approver.show,
            callback: function ($$v) {
              _vm.$set(_vm.approver, "show", $$v)
            },
            expression: "approver.show",
          },
        },
        [
          _c("van-nav-bar", {
            attrs: {
              title: "选择办理人",
              "left-text": "取消",
              "right-text": "确定",
            },
            on: {
              "click-left": function ($event) {
                _vm.approver.show = false
              },
              "click-right": _vm.approverPopupSubmit,
            },
          }),
          _c("van-search", {
            attrs: { clearable: "", shape: "round" },
            on: {
              input: function ($event) {
                return _vm.treeSearch($event, _vm.$refs.approverTree)
              },
            },
            model: {
              value: _vm.approver.filterText,
              callback: function ($$v) {
                _vm.$set(_vm.approver, "filterText", $$v)
              },
              expression: "approver.filterText",
            },
          }),
          _c(
            "div",
            { staticClass: "h-vh-50", staticStyle: { "overflow-y": "auto" } },
            [
              _c(
                "div",
                { staticClass: "p-10" },
                [
                  _c("el-tree", {
                    ref: "approverTree",
                    attrs: {
                      "node-key": "uuid",
                      "check-strictly": "",
                      data: _vm.approver.data,
                      "filter-node-method": _vm.filterNode,
                      "check-on-click-node": "",
                      "show-checkbox": "",
                    },
                    on: {
                      "check-change": function ($event) {
                        return _vm.approverCheckChange(
                          $event,
                          _vm.$refs.approverTree
                        )
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c("account", {
        attrs: { show: _vm.account.show },
        on: {
          finish: _vm.accountFinish,
          close: function ($event) {
            _vm.account.show = false
          },
        },
      }),
      _c("contract", {
        ref: "contractSelect",
        attrs: {
          show: _vm.contract.show,
          userId: _vm.currentUserInfo.userId + "",
        },
        on: {
          finish: _vm.businessSelectFinish,
          close: function ($event) {
            _vm.contract.show = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }